import React from 'react';
import { connect } from 'react-redux';
import styles from './Hour.module.css';
import { PatientCareCenterNoteMiniScheduleAppointment } from './Appointment';


class PatientCareCenterNoteMiniScheduleHour extends React.Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            seconds: 0
        };
    }

    tick() {
        this.setState(state => ({
            seconds: state.seconds + 60
        }));
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let timeOfDay = Date.now() - today.getTime();
        if (this.firstInterval) {
            clearInterval(this.firstInterval);
        }

        if (timeOfDay >= this.props.id * 3600000 && timeOfDay < (this.props.id + 1) * 3600000) {
            this.myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    componentDidMount() {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let timeOfDay = Date.now() - today.getTime();
        if ((this.props.id + 1) * 3600000 >= timeOfDay) {
            this.firstInterval = setInterval(() => this.tick(), 1000);
            this.interval = setInterval(() => this.tick(), 60000);
        }
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (this.firstInterval) {
            clearInterval(this.interval);
        }
    }


    render() {
        return (
            <div className={this.props.isOdd ? styles.wrapperOdd : styles.wrapper} ref={this.myRef}>
                <span className={styles.col1}>{this.props.convertedHour > 12 ? this.props.convertedHour % 12 : this.props.convertedHour}</span>
                <span className={styles.col2}>:{this.props.isHalf}</span>
                <span className={styles.col3}>
                    {Object.keys(this.props.appts)
                        .map(id => {
                            const appt = this.props.appts[id];
                            return <PatientCareCenterNoteMiniScheduleAppointment key={appt.APTID} id={appt.APTID} />
                        })
                    }
                </span>
            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    let appts = Object.keys(state.entities.dashboard.todaysSchedule)
        .filter(x => state.entities.dashboard.todaysSchedule[x].APTSTART >= ownprops.id * 3600000 &&
            state.entities.dashboard.todaysSchedule[x].APTSTART < (ownprops.id + .5) * 3600000)
        .sort((a, b) => {
            if (state.entities.dashboard.todaysSchedule[a].APTSTART !== state.entities.dashboard.todaysSchedule[b].APTSTART) {
                return state.entities.dashboard.todaysSchedule[a].APTSTART - state.entities.dashboard.todaysSchedule[b].APTSTART;
            } else if (state.entities.dashboard.todaysSchedule[a].APTSTART === state.entities.dashboard.todaysSchedule[b].APTSTART &&
                state.entities.dashboard.todaysSchedule[a].APTDURATION !== state.entities.dashboard.todaysSchedule[b].APTDURATION) {
                return state.entities.dashboard.todaysSchedule[a].APTDURATION - state.entities.dashboard.todaysSchedule[b].APTDURATION;
            } else {
                return state.entities.dashboard.todaysSchedule[a].APTID - state.entities.dashboard.todaysSchedule[b].APTID;
            }
        })
        .map(x => state.entities.dashboard.todaysSchedule[x]);

    let isHalf = "00";
    if (ownprops.id % 1 !== 0) {
        isHalf = "30";
    }
    let convertedHour = Math.floor(ownprops.id);


    return {
        appts,
        isHalf,
        convertedHour
    };
}

const connectedPatientCareCenterNoteMiniScheduleHour = connect(mapStateToProps)(PatientCareCenterNoteMiniScheduleHour);
export { connectedPatientCareCenterNoteMiniScheduleHour as PatientCareCenterNoteMiniScheduleHour };

